<template>
  <div
    class="solfigrf-stackpot solfigrstpot"
    :class="[{ gw_loading: loading }, { transition_02: !isPreflop }]"
  >
    <div class="solfigrstpot_content_config">
      <div
        class="solfigrstpot_error_cont"
        :class="{ solfigrstpot_error_cont_error: !isValid }"
      >
        <div class="solfigrstpot_content_config">
          <div
            v-for="(item, idx) in l_options"
            :key="item.id"
            class="solfigrstpot_stack solfigrstpot_item"
            :data-tst="`solfigr_${item.id}`"
          >
            <GwTitleTooltip
              class="solfigrstpot_item_title"
              :title="item.title ? item.title : $t(`solfigr.stackpot.${item.id}`)"
              :tooltip="
                item.tooltip ||
                $t(`solfigr.stackpot.${item.id}_tooltip`, {
                  ratio: conf.stack.flop_stackPotRatioValue,
                })
              "
            />

            <div
              v-if="item.id === 'ante'"
              class="d-flex h-100 gw_loading_text"
            >
              <NumberInput
                :ref="`input_${idx}`"
                class="solfigrstpot_item_input gw_placeholder_text"
                style="--input-width: 5.5rem; --input-radius: 4px 0 0 4px"
                :style="
                  !isValid && item.hasError
                    ? '--clr-focus: var(--clr-error);--clr-outline:var(--clr-error);'
                    : ''
                "
                :stopOnMin="true"
                :hasWheelScroll="false"
                :tabindex="inputTabIndex"
                :min="item.min"
                :max="item.max"
                :step="item.step"
                :decimals="item.decimals"
                :inputmode="item.inputmode"
                :hasPlus="false"
                :hasMinus="false"
                :value="item.value"
                @input="val => handleInput(val, item.prop, item.id)"
              />
              <UnSwitcherNew
                :tab="item.optionValue"
                idKey="id"
                trigger="click"
                class="w-100 my-auto"
                :options="item.options"
                :hasText="true"
                :hasOpener="true"
                :closeOnContentClick="true"
                style="
                  --uns-opener-padding: 0 1.25rem 0 0.75rem;
                  --uns-opener-height: 1.5rem;
                  --uns-opener-clr-back: var(--clr-black-3);
                  --uns-opener-radius: 0 4px 4px 0;
                  margin: 0 0 0 1px;
                  min-width: 90px;
                "
                @click="
                  val =>
                    handleInput(val.id, `anteDistributionMethod`, `${item.id}_distribution_method`)
                "
              />
            </div>
            <div
              v-else-if="item.id === 'blind'"
              class="d-flex h-100 gw_loading_text"
            >
              <NumberInput
                :ref="`input_${idx}`"
                class="solfigrstpot_item_input gw_placeholder_text"
                style="--input-width: 5.5rem; --input-radius: 4px 0 0 4px"
                :style="
                  !isValid && item.hasError
                    ? '--clr-focus: var(--clr-error);--clr-outline:var(--clr-error);'
                    : ''
                "
                :stopOnMin="true"
                :hasWheelScroll="false"
                :tabindex="inputTabIndex"
                :min="item.min"
                :max="item.max"
                :step="item.step"
                :decimals="item.decimals"
                :inputmode="item.inputmode"
                :value="item.value"
                :hasPlus="false"
                :hasMinus="false"
                @input="val => handleInput(val, item.prop, item.id)"
              />
              <div class="cursor-default f-center">
                <NumberInput
                  :ref="`input_${idx}`"
                  class="solfigrstpot_item_input gw_placeholder_text no-events"
                  style="
                    --input-width: 3rem;
                    --input-radius: 0 4px 4px 0;
                    margin: 0 0 0 1px;
                    --input-color: var(--clr-grey-2);
                  "
                  :tabindex="-1"
                  :value="1"
                  :hasPlus="false"
                  :hasMinus="false"
                />
              </div>
            </div>
            <!-- pot, stack-->
            <NumberInput
              v-else
              :ref="`input_${idx}`"
              class="solfigrstpot_item_input gw_loading_text gw_placeholder_text"
              style="--input-width: 5.5rem"
              :style="
                !isValid && item.hasError
                  ? '--clr-focus: var(--clr-error);--clr-outline:var(--clr-error);'
                  : ''
              "
              :stopOnMin="true"
              :hasWheelScroll="false"
              :tabindex="inputTabIndex"
              :min="item.min"
              :max="item.max"
              :step="item.step"
              :decimals="item.decimals"
              :inputmode="item.inputmode"
              :value="item.value"
              @input="val => handleInput(val, item.prop, item.id)"
            />
          </div>
        </div>
        <div
          v-if="!isValid"
          class="solfigrstpot_errormessage mt-2"
        >
          <div class="clr-error text-small f-align-center no-shrink">
            {{
              $t(
                isPreflop
                  ? 'solfigr.stackpot.error_stackblinds'
                  : 'solfigr.stackpot.error_stackpot_ratio',
                {
                  ratio: conf.stack.flop_stackPotRatioValue,
                },
              )
            }}
          </div>
        </div>
      </div>

      <div
        v-if="isPreflop"
        class="mb-auto f-column"
      >
        <GwTitleTooltip
          class="solfigrstpot_item_title"
          :title="$t(`solfigr.stackpot.allow_limp`)"
          :tooltip="$t(`solfigr.stackpot.allow_limp_tooltip`)"
        />

        <GwBtns
          :options="['no_limps', 'has_limps']"
          class="gwbtns_horizontal_grey solfigrtp_top_btns gw_loading_text"
          style="
            border-radius: 4px;
            background: var(--clr-black-1-3);
            --gwbtn-clr-back: var(--clr-black-1-3);
            --gwbtn-clr-active-white: var(--clr-black-3);
            --gwbtn-size: 0.875rem;
            --gwbtns-padding: 2px;
            --gwbtn-height: 1.5rem;
          "
          :value="allowLimp ? 'has_limps' : 'no_limps'"
          @click="
            (_e, item) => {
              handleInput(item === 'has_limps', 'allowLimp', 'allow_limp')
            }
          "
        >
          <template #default="{ item }">
            {{ $t(`solfigr.${item}`) }}
          </template>
        </GwBtns>
      </div>
    </div>
    <div class="f-column solfigrstpot_content_config">
      <div class="mb-auto f-column mr-auto">
        <GwTitleTooltip
          class="solfigrstpot_item_title"
          :title="$t(`solfigr.stackpot.allow_rake`)"
          :tooltip="$t(`solfigr.stackpot.allow_rake_tooltip`)"
        />
        <div
          class="d-flex"
          style="gap: 0.75rem"
        >
          <GwBtns
            :options="['no_rake', 'has_rake']"
            class="gwbtns_horizontal_grey solfigrtp_top_btns gw_loading_text position-relative"
            style="
              border-radius: 4px;
              background: var(--clr-black-1-3);
              --gwbtn-clr-back: var(--clr-black-1-3);
              --gwbtn-clr-active-white: var(--clr-black-3);
              --gwbtn-size: 1rem;
              --gwbtn-height: 1.875rem;
              --gwbtns-padding: 2px;
            "
            :value="allowRake ? 'has_rake' : 'no_rake'"
            @click="
              (_e, item) => {
                if ($refs.rake_pulse) {
                  $refs.rake_pulse.close()
                }
                handleInput(
                  item === 'has_rake',
                  'allowRake',
                  `allowRake_${isPreflop ? 'preflop' : 'flop'}`,
                )
              }
            "
          >
            <template #default="{ item }">
              {{ $t(`solfigr.${item}`) }}
            </template>
          </GwBtns>
          <div
            v-if="allowRake"
            class="gw_btn-v1 gw_btn_text gw_btn_outline weight_500 mt-auto my-auto"
            style="--height: 1.875rem; font-size: 0.8rem"
            data-tst="solfigr_rake_prefill_btn"
            @click="openRakePrefillDialog()"
          >
            <i class="text-normal mdi mdi-auto-fix mr-2"></i>
            {{ $t(`solfigr.prefill_rake`) }}
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="allowRake"
      class="solfigrstpot_content_config"
    >
      <div
        v-for="(item, idx) in rakeOptions"
        :key="item.id"
        class="solfigrstpot_stack solfigrstpot_item"
        :data-tst="`solfigr_${item.id}`"
      >
        <GwTitleTooltip
          class="solfigrstpot_item_title"
          :title="item.title"
          :tooltip="item.tooltip"
        />
        <UnSwitcherNew
          v-if="item.id === 'preflopRakeType'"
          class="w-100 my-auto"
          idKey="id"
          trigger="click"
          :tab="item.value"
          :options="item.options"
          :hasText="true"
          :hasOpener="true"
          :closeOnContentClick="true"
          style="
            --uns-opener-height: 1.5rem;
            --uns-opener-clr-back: var(--clr-black-3);
            --uns-opener-padding: 0 1.5rem 0 0.5rem;
          "
          @click="val => handleInput(val.id, `preflopRakeType`, `preflopRakeType`)"
        />
        <NumberInput
          v-else
          :ref="`input_${idx}`"
          class="solfigrstpot_item_input gw_loading_text gw_placeholder_text"
          style="--input-width: 5.5rem"
          :style="
            !isValid && item.hasError
              ? '--clr-focus: var(--clr-error);--clr-outline:var(--clr-error);'
              : ''
          "
          :stopOnMin="true"
          :hasWheelScroll="false"
          :tabindex="inputTabIndex"
          :min="item.min"
          :max="item.max"
          :step="item.step"
          :decimals="item.decimals"
          :inputmode="item.inputmode"
          :value="item.value"
          @input="val => handleInput(val, item.prop, item.id)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import NumberInput from '@/components/lib/NumberInput'
import GwTitleTooltip from '@/components/Dialogs/UserSettingsDialog/GwTitleTooltip'
import GwBtns from '@/components/lib/GwBtns'
import Snackbar from '@/components/Messages/Snackbar'
import { getSolfigrFields } from '@/store/solfigr/solfigr_helpers'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'SolfigrStreetInputs',
  components: {
    UnSwitcherNew,
    NumberInput,
    GwTitleTooltip,
    GwBtns,
    Snackbar,
  },
  mixins: [float_mix],
  props: {
    namespace: { String, required: true },
    isPreflop: Boolean,
    pot: Number,
    stack: Number,
    blind: Number,
    ante: Number,
    rakePercent: Number,
    rakeCap: Number,
    preflopRakeType: String,
    anteDistributionMethod: String,
    allowLimp: Boolean,
    allowRake: Boolean,
    loading: Boolean,
    players: Array,
    inputTabIndex: { default: 1 }, // for mobile numeric navigation
  },
  emits: ['update:input'],
  data() {
    this.conf = getSolfigrFields()
    return {}
  },
  mounted() {
    nextTick(() => {
      if (this.loading) return
      this.focusInput()
    })
  },
  methods: {
    handleInput(val, prop, id) {
      if (this[prop] === val) return
      this.$emit(`update:input`, { type: id, num: val })
    },
    focusInput() {
      const cc = this.$refs.input_0
      if (cc) {
        cc[0].focusInput('moveCaretToEnd')
      }
    },
    openRakePrefillDialog() {
      const dialog = `solfigr-rake-dialog_namespace-${this.namespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
  },
  computed: {
    l_options() {
      const res = [
        {
          ...this.conf.pot, //
          id: 'pot',
          prop: 'pot',
          value: this.pot,
          hidden: this.isPreflop,
          hasError: true,
        },
        {
          ...this.conf.stack,
          id: this.isPreflop ? 'stack_preflop' : 'stack_flop',
          prop: 'stack',
          value: this.stack,
          max: this.isPreflop ? this.conf.stack.max_preflop : this.conf.stack.max,
          hasError: true,
          hidden:
            !this.isPreflop &&
            this.$store.getters.user_has_flag('SOL_3WAY') &&
            this.players.length > 2,
        },
        {
          ...this.conf.blind,
          id: 'blind',
          prop: 'blind',
          title: this.$t(`solfigr.xxx_in_bb`, { str: 'SB/BB' }),
          value: this.blind,
          hidden: !this.isPreflop,
        },
        {
          ...this.conf.ante,
          id: 'ante',
          prop: 'ante',
          title: this.$t(`solfigr.xxx_in_bb`, { str: 'Ante' }),
          value: this.ante,
          hidden: !this.isPreflop,
          options: [
            'PER_PLAYER', //
            'TOTAL',
            'BB_ANTE',
          ].map(id => ({
            id,
            text: this.$t(`solfigr.ante_distribution_method.${id}`),
          })),
          optionValue: this.anteDistributionMethod,
        },
        // ...(!this.isPreflop ? this.rakeOptions : []),
      ].filter(item => !item.hidden)
      // console.log(res)
      return res
    },
    rakeOptions() {
      const res = [
        {
          ...this.conf.rakePercent,
          id: this.isPreflop ? 'rakePercent_preflop' : 'rakePercent_flop',
          prop: 'rakePercent',
          title: this.$t(`solfigr.rakePercent`),
          tooltip: this.$t(`solfigr.rakePercent_tooltip`),
          value: this.rakePercent,
        },
        {
          ...this.conf.rakeCap,
          id: this.isPreflop ? 'rakeCap_preflop' : 'rakeCap_flop',
          prop: 'rakeCap',
          title: this.$t(`solfigr.rakeCap`),
          tooltip: this.$t(`solfigr.rakeCap_tooltip`),
          value: this.rakeCap,
        },
        {
          ...this.conf.preflopRakeType,
          id: 'preflopRakeType',
          prop: 'preflopRakeType',
          title: this.$t(`solfigr.preflopRakeType`),
          tooltip: this.$t(`solfigr.preflopRakeType_tooltip`),
          options: [
            'no_flop_no_drop', //
            'gg_network',
            'full',
          ].map(id => ({
            id,
            text: this.$t(`solfigr.rake.${id}`),
          })),
          value: this.preflopRakeType,
          hidden: !this.isPreflop,
        },
      ].filter(item => !item.hidden)
      // console.log(res)
      return res
    },
    isValid() {
      if (this.isPreflop)
        return this.conf.stack.preflop_stackAnteBlindCheck({
          stack: this.stack,
          ante: this.ante,
          preflop_SB: this.blind,
        })

      return this.conf.stack.flop_stackPotCheck({
        stack: this.stack,
        pot: this.pot,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.solfigrstpot {
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  position: relative;
  gap: 1rem;
  &_error_cont {
    padding: 0;
    border-radius: 4px;
    transition: 0.22s;
    box-shadow: 0px 0px 0px 1px transparent;
    &_error {
      padding: 0.5rem;
      box-shadow: 0px 0px 0px 1px var(--clr-error);
    }
  }
  &_content,
  &_content_config {
    gap: 1rem;
    display: flex;
    flex-wrap: wrap;
  }
  &_item {
    display: flex;
    flex-direction: column;
    &_title {
      margin: 0 0 0.25rem 0;
    }
  }
}
</style>
